import { ComponentProps } from "react";
import { createTheme } from "flowbite-react";

const h1Theme = createTheme({
  h1: {
    base: "text-2xl sm:text-3xl font-semibold ",
    colors: {
      base: "text-foreground",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
    },
  },
}).h1;

type H1Props = {
  children: React.ReactNode
  color?: keyof typeof h1Theme.colors
  className?: string
} & ComponentProps<"h1">;

const H1 = ({
  children,
  color = "base",
  className = "",
  ...props
}: H1Props) => {
  return (
    <h1
      className={`${h1Theme.base} ${h1Theme.colors[color]} ${className}`}
      {...props}
    >
      {children}
    </h1>
  );
};

H1.displayName = "H1";

export { H1 };
export type { H1Props };
